export default function TemplatesIcon() {
  return (
    <svg viewBox="0 0 16.5 22.24" className="twenty-two">
      <path
        id="Path_1999"
        d="M15.53,0H.96C.43,0,0,.43,0,.96V21.27c0,.53,.43,.96,.96,.96H15.53c.53,0,.96-.43,.96-.96V.96c0-.53-.43-.96-.96-.96m-.96,20.31H1.92V1.93H14.57V20.31Z"
      />
      <path
        id="Path_2000"
        d="M10.62,5.91l-.18,.31,.33,.15-.03,.36h.37l.12,.35,.34-.14,.25,.26,.25-.26,.33,.14,.12-.34h.36l-.03-.36,.32-.16-.18-.32,.24-.28-.29-.22,.11-.35-.35-.08-.05-.36-.36,.07-.18-.31-.3,.21-.3-.2-.18,.31-.36-.07-.05,.36-.35,.08,.11,.35-.29,.22,.24,.27Z"
      />
      <path
        id="Path_2001"
        d="M8.59,6.61H3.61c-.32,0-.57-.26-.57-.57s.26-.57,.57-.57h4.98c.32,0,.57,.26,.57,.57,0,.32-.26,.57-.57,.57"
      />
      <path
        id="Path_2002"
        d="M12.63,15.13h-2.9c-.32,0-.57-.26-.57-.57,0-.32,.26-.57,.57-.57h2.9c.32,0,.57,.26,.57,.57,0,.32-.26,.57-.57,.57"
      />
      <path
        id="Path_2003"
        d="M12.63,10.87h-2.9c-.32,0-.57-.26-.57-.57,0-.32,.26-.57,.57-.57h2.9c.32,0,.57,.26,.57,.57,0,.32-.26,.57-.57,.57"
      />
      <path
        id="Path_2004"
        d="M7.31,10.87H3.61c-.32,0-.57-.26-.57-.57,0-.32,.26-.57,.57-.57h3.7c.32,0,.57,.26,.57,.57,0,.32-.26,.57-.57,.57"
      />
      <path
        id="Path_2005"
        d="M7.43,17.85H3.72c-.25,0-.45-.2-.45-.45h0v-3.12c0-.25,.2-.45,.45-.45h3.72c.25,0,.45,.2,.45,.45h0v3.12c0,.25-.2,.45-.45,.45h0"
      />
    </svg>
  );
}
